import React from "react";

/** Eyebrow + heading (+ optional intro paragraph). `center` stacks and centres everything. */
export default function SectionTitle({ eyebrow, title, text, center = false }) {
  return (
    <div className={`section-title${center ? " section-title--center" : ""}`}>
      <div>
        {eyebrow && <div className="kicker">{eyebrow}</div>}
        <h2>{title}</h2>
      </div>
      {text && <p className="lead">{text}</p>}
    </div>
  );
}
